import styled from 'styled-components';

const ClearAllFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  color: var(--white);
  cursor: pointer;
  margin-bottom: 6px;

  & > span {
    padding-right: 6px;
    font-family: var(--luft-fonts);
    font-size: 14px;
  }

  &:hover {
    opacity: 0.6;
  }
`;

// -disable-next-line import/prefer-default-export
export const S = {
  ClearAllFiltersContainer,
};
